import * as cx from 'classnames';
import { COMPLAINTS_REPORTED_BY } from 'mk/autogenerated/translations/Complaints.32e68ff0fb76c6a4cd8a9c5efd97412e'
import { user_profile_url } from 'mk/urls/functions';
import { ComplaintEntity } from 'mk2/containers/Complaint/Complaint.schemas';
import { complaintsDelete } from 'mk2/containers/Complaints/Complaints.actions';
import { getComplaintsComplaints } from 'mk2/containers/Complaints/Complaints.selectors';
import { timeAt } from 'mk2/helpers/timeformat';
import { AppState } from 'mk2/reducers';
import * as React from 'react';
import { connect } from 'react-redux';
import styles from './Complaints.mscss';

interface OwnProps {
    className?: string;
    id: number;
    entity: string;
    deleteLabel: string;
}

interface StateProps {
    complaints: ComplaintEntity[];
}

interface DispatchProps {
    onDelete();
}

type Props = OwnProps & StateProps & DispatchProps;

class Complaints extends React.Component<Props> {

    public render() {
        const { className, complaints, deleteLabel, onDelete } = this.props;

        if (!complaints || !complaints.length) {
            return null;
        }

        return (
            <div className={cx(styles.Complaints, className)}>
                {complaints.map((complaint) => (
                    <div key={complaint.id} className={styles.Complaints__item}>
                        <div className={styles.Complaints__item__meta}>
                            {timeAt(complaint.createdAt)}
                            {' '}
                            {COMPLAINTS_REPORTED_BY}
                            {' '}
                            <a href={user_profile_url(complaint.user.username)} className={styles.Complaints__item__meta__link}>
                                {complaint.user.username}
                            </a>
                        </div>

                        <div className={styles.Complaints__item__content}>
                            {complaint.comment}
                        </div>
                    </div>
                ))}

                <button className={styles.Complaints__delete} onClick={onDelete} type="button">
                    {deleteLabel}
                </button>
            </div>
        );
    }

}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        complaints: getComplaintsComplaints(state, ownProps.entity, ownProps.id),
    };
}

function mapDispatchToProps(dispatch, ownProps: OwnProps): DispatchProps {
    return {
        onDelete: () => dispatch(complaintsDelete(ownProps.entity, ownProps.id)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Complaints);
